import classnames from 'classnames';

import PageLayout from '@/components/organisms/PageLayout';
import Title from '@/components/atoms/Title';

import styles from './index.module.css';
import ButtonGameState from '@/components/atoms/ButtonGameState';
import { route3 } from '@/utils/data';

export interface LayoutAboutResonanceProp {
    className?: string;
    loading?: boolean;
    active?: boolean;
}

const LayoutAboutResonance: React.FC<LayoutAboutResonanceProp> = ({
    className,
    loading,
    active,
}) => (
    <PageLayout loading={loading} active={active}>
        <div className={classnames(styles.layoutAboutLove, className)}>
            <Title className={styles.title}>{route3.title}</Title>
            <section className={styles.intro}>{route3.fullContent}</section>
            <div className={styles.itemWrapper}>
                {route3.infos.map(({ label, value, fullContent, hideOnDetailView }) => {
                    if (hideOnDetailView) return null;

                    return (
                        <div className={styles.item}>
                            <div className={styles.name}>{label}</div>
                            <div className={classnames(styles.value)}>{fullContent || value}</div>
                        </div>
                    );
                })}
            </div>
            <ButtonGameState className={styles.btn} status={route3.status} link={route3.link} />
        </div>
    </PageLayout>
);

export default LayoutAboutResonance;
